import React from "react";
export const MenuList = [
  //Dashboard
  {
    title: "Dashboard",
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-381-networking"></i>,
    tooltip: "Dashboard",
    content: [
      { 
        title: "Telecaller", 
        to: "/telecaller",
        iconStyle: <i className="flaticon-381-networking"></i>,
      },
      { 
        title: "Receptionist", 
        to: "/receptionist",
        iconStyle:  <i className="flaticon-381-networking"></i>,
      },
      { 
        title: "Doctor", 
        to: "/doctor",
        iconStyle:  <i className="flaticon-381-networking"></i>,
      },
      { 
        title: "Counsellor", 
        to: "/counsellor",
        iconStyle:  <i className="flaticon-381-networking"></i>,
      },
      { 
        title: "Medical", 
        to: "/medical",
        iconStyle: <i className="flaticon-381-networking"></i>,
      },
      { 
        title: "Service Caller", 
        to: "/service-caller",
        iconStyle:  <i className="flaticon-381-networking"></i>,
      },
    ],
  },
//   {
//     title: 'Appointment',
//     tooltip: "Appointment",
//     iconStyle: <i className="flaticon-381-menu"></i>,
//     to: 'appointments',
//     content: [
//         {
//             title: "Appointments",
//             to: "/appointments",
//                module_id: "8"
//         }
//     ],
  
// },

{
  title: "Appointment",
  iconStyle: <i className="flaticon-381-menu"></i>,
  content: [
    {
      title: "Appointments",
      to: "/appointments",
      module_id: "31",
    },
  ],
},

  //Users

  // {
  //   title: "Panchkarma",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-briefcase"></i>,
  //   content: [
  //     {
  //       title: "Dashboard",
  //       to: "/panchkarma",
  //       module_id: "20",
  //     },
  //     {
  //       title: "Therapist",
  //       to: "/therapist",
  //       //module_id: "22",
  //     },
  //     {
  //       title: "Users",
  //       to: "/panchkarma-users",
  //       module_id: "21",
  //     },
  //     {
  //       title: "Karma",
  //       to: "/karma",
  //       module_id: "22",
  //     },
  //     {
  //       title: "Patients",
  //       to: "/patients",
  //       module_id: "23",
  //     },
  //     {
  //       title: "Service Caller",
  //       to: "/panchkarma-service-caller",
  //       //module_id: "XX", // 
  //     },
  //   ],
  // },
  
  //Apps
  {
    title: "Patients",
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-381-notebook-1"></i>,
    content: [
      { title: "Leads", to: "/app-leads", module_id: "7" },
      { title: "Assigned History", to: "/assigned-history", module_id: "20" },
      { title: "Patients", to: "/app-patients", module_id: "8" },
      { title: "Import Leads", to: "/app-import-leads", module_id: "9" },
      { title: "Service caller reassignment", to: "/app-service-caller-reassignment", module_id: "39" },
    ],
  },
  // Questionnaire
  // {
  //   title: "Questionnaire",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-network"></i>,
  //   content: [
  //     {
  //       title: "Questions",
  //       to: "/questions",
  //       module_id: "10",
  //     },

  //     {
  //       title: "Forms",
  //       to: "/forms",
  //       module_id: "11",
  //     },
  //   ],
  // },
  {
    title: "Questionnaire",
    iconStyle: <i className="flaticon-381-notepad"></i>,
    content: [
      { title: "Questions", to: "/questions", module_id: "10" },
      { title: "Forms", to: "/forms", module_id: "11" },
    ],
  },
  //Master
  // {
  //   title: "Master",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-internet"></i>,
  //   content: [
  //     {
  //       title: "Branches",
  //       to: "/branch",
  //       module_id: "12",
  //     },
  //     {
  //       title: "Departments",
  //       to: "/department",
  //       module_id: "13",
  //     },
  //     {
  //       title: "Categories",
  //       to: "/categories",
  //       module_id: "14",
  //     },
  //     {
  //       title: "Symptoms",
  //       to: "/symptoms",
  //       module_id: "15",
  //     },
  //     {
  //       title: "Diseases",
  //       to: "/diseases",
  //       module_id: "16",
  //     },
  //     {
  //       title: "Medicines",
  //       to: "/medicine",
  //       module_id: "17",
  //     },
  //     // {
  //     //   title: "Disease Medicine Mapping",
  //     //   to: "/disease-medicine-mapping",
  //     //   module_id: "18",
  //     // },

  //     // {
  //     //   title: "Symptom Medicine Mapping",
  //     //   to: "/symptom-medicine-mapping",
  //     //   module_id : "20"
  //     // }
  //     {
  //       title: "Content Bank",
  //       to: "/content-bank",
  //       module_id: "20",
  //     },
  //     {
  //       title: "Scripts",
  //       to: "/script",
  //       module_id: "21",
  //     },
  //     {
  //       title: "Objection",
  //       to: "/objection",
  //       // module_id: "21",
  //     },
  //     {
  //       title: "Note Categories",
  //       to: "/note-categories",
  //       // module_id: "21",
  //     },
  //     {
  //       title: "Pathyas",
  //       to: "/pathyas",
  //       // module_id: "17",
  //     },

  //     {
  //       title: "Default Dose",
  //       to: "/defaultDose",
  //       // module_id: "17",
  //     },
  //     {
  //       title: "Unit Of Dose",
  //       to: "/unit-of-dose",
  //       // module_id: "17",
  //     },
  //     {
  //       title: "How To Take",
  //       to: "/how-to-take",
  //       // module_id: "17",
  //     },
  //     {
  //       title: "Frequency",
  //       to: "/frequency",
  //       // module_id: "17",
  //     },
  //     {
  //       title: "Campaign",
  //       to: "/campaign",
  //       // module_id: "17",
  //     },
  //     // {
  //     //   title: "Users",
  //     //   to: "ui-user",
  //     // },
  //   ],
  // },
  {
    title: "Master",
    iconStyle: <i className="flaticon-381-database"></i>,
    content: [
      { title: "Branches", to: "/branches", module_id: "12" },
      { title: "Departments", to: "/departments", module_id: "13" },
      { title: "Categories", to: "/categories", module_id: "14" },
      { title: "Symptoms", to: "/symptoms", module_id: "15" },
      { title: "Diseases", to: "/diseases", module_id: "16" },
      { title: "Pathyas", to: "/pathyas",module_id: "21" },
      { title: "Medicine Type", to: "/medicine-types", module_id: "22" },
      { title: "Default Dose", to: "/default-dose", module_id: "23" },
      { title: "Unit Of Dose", to: "/app-unit-of-dose", module_id: "24" },
      { title: "How To Take", to: "/app-how-to-take", module_id: "25" },
      { title: "Frequency", to: "/frequency", module_id: "26" },
      { title: "Anupan", to: "/app-anupan", module_id: "27" },
      { title: "Medicines", to: "/medicines", module_id: "17" },
      { title: "Content Bank", to: "/content-bank", module_id: "" },
      { title: "Scripts", to: "/scripts", module_id: "35" },
      { title: "Objections", to: "/objections", module_id: "28" },
      { title: "Note Categories", to: "/note-categories", module_id: "29" },
      { title: "Campaign", to: "/campaign",  module_id: "30"},
    ],
  },

  // {
  //   title: "Panchkarma",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-heart"></i>,
  //   content: [
  //     {
  //       title: "Dashboard",
  //       to: "/panchkarma",
  //       //module_id: "22",
  //     },
  //     {
  //       title: "Karma",
  //       to: "/karma",
  //       //module_id: "22",
  //     },
  //     {
  //       title: "Users",
  //       to: "/panchkarma-users",
  //       //module_id: "23",
  //     },
  //     {
  //       title: "Patients",
  //       to: "/patients",
  //       //module_id: "24",
  //     },
  //     {
  //       title: "Service Caller",
  //       to: "/panchkarma-service-caller",
  //       //module_id: "XX", // 
  //     },
  //   ],
  // },

  {
    title: "Users",
    iconStyle: <i className="flaticon-381-id-card-4"></i>,
    content: [
      { title: "Roles", to: "/roles", module_id: "6" },
      { title: "Monthly Target", to: "/monthly-target", module_id: "33" },
      { title: "Users", to: "/users", module_id: "5" },
      { title: "Doctors", to: "/doctors", module_id: "19" },
    ],
  },

  //Settings
  {
    title: "Settings",
    iconStyle: <i className="flaticon-381-settings-2"></i>,
    content: [
      { title: "Site Settings", to: "/site-setting", module_id: "36"},
      { title: "Patient Review List", to: "/app-patient-review-list", module_id: "37" },
      { title: "GST", to: "/gst", module_id: "38" },
    ],
  },
  {
    title: "Stock ",
    iconStyle: <i className="flaticon-381-box"></i>, 
    module_id: "40",
    content: [
      {
        title: "Batch QRs",
        to: "/batch-QRs",
        module_id: "41" 
      },
      {
        title: "Inward Stock",
        to: "/inward-stock",
        module_id: "42" 
      },
      {
        title: "Stock Transactions",
        to: "/stock-transactions",
        module_id: "43" 
      },
    ],
  }
];
